import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { create } from "zustand";
import { devtools } from "zustand/middleware";
/** Global store remembering each tag action's pre-apply value so done tags can be undone. */
export var useTagUndoStore = create()(devtools(function (set) {
  return {
    oldValues: {},
    remember: function remember(actionId, value) {
      return set(function (s) {
        return {
          oldValues: _objectSpread(_objectSpread({}, s.oldValues), {}, _defineProperty({}, actionId, value))
        };
      }, false, "remember");
    },
    forget: function forget(actionId) {
      return set(function (s) {
        var next = _objectSpread({}, s.oldValues);
        delete next[actionId];
        return {
          oldValues: next
        };
      }, false, "forget");
    },
    reset: function reset() {
      return set({
        oldValues: {}
      }, false, "reset");
    }
  };
}, {
  name: "TagUndoStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));